import API from "./API";

const MSG91_AUTH_KEY = process.env.NEXT_PUBLIC_MSG91_AUTH_KEY;
const MSG91_ACCESS_TOKEN =
  process.env.NEXT_PUBLIC_MSG91_ACCESS_TOKEN ||
  process.env.MSG91_ACCESS_TOKEN;

async function parseJson(response) {
  const data = await response.json();

  if (!response.ok) {
    const error = new Error(data?.message || "Request failed");
    error.response = {
      data,
      status: response.status,
    };
    throw error;
  }

  return data;
}

export const verifyOtpWidjetApi = async () => {
  const response = await fetch(
    "https://control.msg91.com/api/v5/widget/verifyAccessToken",
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        authkey: MSG91_AUTH_KEY,
        "access-token": MSG91_ACCESS_TOKEN,
      }),
    },
  );

  return parseJson(response);
};

export async function sendOtpApi(payload) {
  const { mobileNumber, mobileNo } = payload || {};
  const mobile = mobileNumber || mobileNo;

  const response = await API.post(
    `/otp/send?mobileNumber=${encodeURIComponent(mobile || "")}`,
  );
  return response;
}

export async function verifyOtpApi(payload) {
  const { mobileNumber, mobileNo, otp } = payload || {};
  const mobile = mobileNumber || mobileNo;

  const response = await API.post(
    `/otp/verify?mobileNumber=${encodeURIComponent(
      mobile || "",
    )}&otp=${encodeURIComponent(otp || "")}`,
  );
  return response;
}

export const resentOtpApi = async (payload) => {
  const { mobileNumber, mobileNo } = payload || {};
  const mobile = mobileNumber || mobileNo;

  const response = await API.post(
    `/otp/resend?mobileNumber=${encodeURIComponent(mobile || "")}`,
  );
  return response;
};

export const socialSignUpApi = async (payload) => {
  try {
    const response = await API.post(`/auth/social/signup`, payload);
    return response;
  } catch (error) {
    throw error;
  }
};
